import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  DASHBOARD_SPA_APPOINTMENTS_VIEW,
  SPA_STATUS_ACCEPTED,
  SPA_STATUS_ARRIVING_TODAY,
  SPA_STATUS_COMPLETED,
  SPA_STATUS_DECLINED,
  SPA_STATUS_GUEST_DECLINED,
  SPA_STATUS_NEW_REQUEST,
  SPA_STATUS_SCHEDULED,
} from '../../../../constants/DashboardConst';
import ActivationPopupModel from '../../../../shared/activation-popup/Activation-Popup';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { updateSpaDashboardOrderStatus } from '../../../../utils/dashboardAPIUtils';
import { formatDate, formatTimeSlot } from '../../../../utils/dashboardUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { selectedHotelCurrencySelector } from '../../../property/propertySlice';
import {
  dashboardSpaListSelector,
  fetchSpaDashboardOrderList,
  setDashboardNewOrder,
} from '../../DashboardSlice';
import './DashboardSpaView.scss';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../env/Configurations';

const DashboardSpaView = (props) => {
  const { obj, onViewToggle, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const allDashboardSpaList = useSelector(dashboardSpaListSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const [order, setOrder] = useState(null);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    type: '',
    descriptionClass: 'delete-popup-description',
  });

  useEffect(() => {
    const currOrder = allDashboardSpaList.find(
      (dashboardIRDList) => dashboardIRDList.id === obj.id,
    );
    if (currOrder) setOrder(currOrder);
  }, [obj, allDashboardSpaList]);

  const onClickBack = () => {
    dispatch(setDashboardNewOrder(null));
    onViewToggle('', false, null);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      type: '',
      descriptionClass: 'delete-popup-description',
    });
  };

  const onUpdatingStatus = async (newStatus, successMessage, errorMessage) => {
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';
      if (
        order?.status !== SPA_STATUS_NEW_REQUEST &&
        (newStatus === SPA_STATUS_ACCEPTED || newStatus === SPA_STATUS_DECLINED)
      )
        return false;
      if (
        order?.status !== SPA_STATUS_ARRIVING_TODAY &&
        order?.status !== SPA_STATUS_SCHEDULED &&
        (newStatus === SPA_STATUS_COMPLETED || newStatus === SPA_STATUS_GUEST_DECLINED)
      )
        return false;

      if (order?.id) {
        await updateSpaDashboardOrderStatus(hotelId, order.id, newStatus, language);
        await dispatch(fetchSpaDashboardOrderList(hotelId));
        notificationManager('success', successMessage);
      }
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors ? error?.graphQLErrors?.[0]?.message : errorMessage,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    return true;
  };

  const onClickDeclineRequest = () => {
    if (order?.status !== SPA_STATUS_NEW_REQUEST) return false;
    setSelectedValue({
      id: order.id,
      name: '',
      title: 'Reject Request?',
      description:
        'Are you sure you want to reject this request? An email will be sent to ' +
        order?.guestName +
        ' regarding their booking request status',
      status: true,
      type: 'reject',
      descriptionClass: 'delete-popup-description-black',
    });
  };

  const onClickGuestCancelled = () => {
    if (order?.status === SPA_STATUS_ARRIVING_TODAY || order?.status === SPA_STATUS_SCHEDULED) {
      setSelectedValue({
        id: order.id,
        name: '',
        title: 'Oh no! Guest Cancelled ?',
        description:
          'This scheduled appointment will be removed from the list. This action cannot be reversed.',
        status: true,
        type: 'guest_cancel',
        descriptionClass: 'delete-popup-description-black',
      });
    }
  };

  const onClickCompleteRequest = () => {
    if (order?.status === SPA_STATUS_ARRIVING_TODAY || order?.status === SPA_STATUS_SCHEDULED) {
      setSelectedValue({
        id: order.id,
        name: '',
        title: 'Complete Appointment ?',
        description: 'This action cannot be reversed.',
        status: true,
        type: 'complete',
        descriptionClass: 'delete-popup-description-black',
      });
    }
  };

  const onOkClick = () => {
    try {
      dispatch(stepUpLoaderCount());
      if (selectedValue?.type === 'reject') {
        onUpdatingStatus(
          SPA_STATUS_DECLINED,
          'Request Rejected successfully',
          'Error occurred while rejecting request',
        );
      }
      if (selectedValue?.type === 'guest_cancel') {
        onUpdatingStatus(
          SPA_STATUS_GUEST_DECLINED,
          'Request Cancelled successfully',
          'Error occurred while cancelling request',
        );
      }
      if (selectedValue?.type === 'complete') {
        onUpdatingStatus(
          SPA_STATUS_COMPLETED,
          'Request Completed successfully',
          'Error occurred while completing request',
        );
      }
      handleClose();
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager(
        'danger',
        `${
          error?.graphQLErrors ? error?.graphQLErrors?.[0]?.message : 'Error occurred while viewing'
        }`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <>
      {order === null ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        <div className='spa-dashboard-view container mt-4 mb-3 detail-view-65 pb-4'>
          <div className='mt-5 row mx-0'>
            <div className='col-md-6 px-0 d-flex align-items-center'>
              <Button
                variant='text'
                color='secondary'
                size='small'
                startIcon={<ArrowBack />}
                onClick={(e) => onClickBack()}
                className='me-2'
              >
                Back
              </Button>
              <span className='page-title'>{order?.guestName}</span>
            </div>
            <div className='col-md-6 d-flex justify-content-end'>
              <Button
                className='py-2'
                variant='outlined'
                color='secondary'
                size='medium'
                endIcon={<ArrowRightIcon />}
                onClick={() => onViewToggle(DASHBOARD_SPA_APPOINTMENTS_VIEW, true, obj)}
              >
                Appointments
              </Button>
            </div>
          </div>
          <div className='card shadow mt-4 mb-4 pb-5 h-100 px-4 pt-4'>
            <div className='row mb-4'>
              <div className='col-md-5'>
                <div className='details-label'>Request Id</div>
                <div className='details-value'>{order?.id}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Date & Time</div>
                <div className='details-value'>
                  {formatDate(order?.bookingTime, 'DD MMM, hh:mm a')}
                </div>
              </div>
              <div className='col-md-3'>
                <div className='details-label'>Status</div>
                <div className={`status ${order?.statusClass}`}>{order?.orderStatus}</div>
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-md-5'>
                <div className='details-label'>Guest name</div>
                <div className='details-value'>{order?.guestName}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Guest Type</div>
                <div className='details-value'>
                  {order.guestType === 'resident'
                    ? `Resident - Room ${order?.roomNo === '' ? '---' : order?.roomNo}`
                    : 'Non Resident'}
                </div>
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-md-5'>
                <div className='details-label'>No of Guests</div>
                <div className='details-value'>{('0' + order?.numberOfGuest).slice(-2)}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Pax</div>
                <div className='details-value'>{order?.pax}</div>
              </div>
              <div className='col-md-3'>
                <div className='details-label'>
                  {order?.status === SPA_STATUS_ARRIVING_TODAY ||
                  order?.status === SPA_STATUS_SCHEDULED ||
                  order?.status === SPA_STATUS_COMPLETED ||
                  order?.status === SPA_STATUS_GUEST_DECLINED
                    ? 'Scheduled Date'
                    : 'Requested Date'}
                </div>
                <div className='details-value'>{formatDate(order?.scheduledDate, 'DD MMM')}</div>
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-md-5'>
                <div className='details-label'>
                  {order?.status === SPA_STATUS_ARRIVING_TODAY ||
                  order?.status === SPA_STATUS_SCHEDULED ||
                  order?.status === SPA_STATUS_COMPLETED ||
                  order?.status === SPA_STATUS_GUEST_DECLINED
                    ? 'Scheduled Time Slot'
                    : 'Requested Time Slot'}
                </div>
                <div className='details-value'>
                  {formatTimeSlot(order?.scheduledTime, order.treatmentDuration)}
                </div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Treatment Duration</div>
                <div className='details-value'>{order?.treatmentDuration} minutes</div>
              </div>
              <div className='col-md-3'>
                <div className='details-label'>Total Bill Amount</div>
                <div className='details-value'>
                  {currency} {order?.totalAmount}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='details-label mb-2'>Treatment</div>
                {order?.items?.map((currentItem, key) => (
                  <div key={key}>
                    <Accordion className='mb-2'>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id='panel1a-header'
                        className='accordion-summary'
                      >
                        <Typography
                          sx={{
                            width: '60%',
                            flexShrink: 0,
                            color: '#707070',
                            fontSize: '16px',
                          }}
                        >
                          {currentItem?.name}
                        </Typography>
                        <Typography
                          sx={{ width: '20%', flexShrink: 0 }}
                          className='accordion-summary-text'
                        >
                          {currentItem?.treatmentDuration} min
                        </Typography>
                        <Typography
                          sx={{ width: '20%', flexShrink: 0 }}
                          className='accordion-summary-text'
                        >
                          {currency} {currentItem?.amount}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className='accordion-details'>
                        <div className='row'>
                          <div className='col-md-2'>
                            {currentItem.image && (
                              <img
                                src={currentItem.image}
                                alt='user'
                                className={currentItem?.name}
                              />
                            )}
                          </div>
                          <div className='col-md-10'>
                            <div className='row'>
                              <div className='col-md-12 details-text'>
                                {currentItem.description}
                              </div>
                            </div>
                            <div className='row mt-2'>
                              <div className='col-md-3'>Special Requestes:</div>
                              <div className='col-md-9 details-text'>
                                {currentItem.specialRequest}
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))}
              </div>
            </div>
            <div className='row mt-5'>
              <div className='col-md-7'>
                {(order?.status === SPA_STATUS_NEW_REQUEST ||
                  order?.status === SPA_STATUS_ARRIVING_TODAY ||
                  order?.status === SPA_STATUS_SCHEDULED) && (
                  <Button
                    className={
                      order?.status === SPA_STATUS_NEW_REQUEST ? '' : 'accepted-button-static'
                    }
                    variant={order?.status === SPA_STATUS_NEW_REQUEST ? 'contained' : 'outlined'}
                    color='primary'
                    type='button'
                    onClick={() =>
                      onUpdatingStatus(
                        'ACCEPTED',
                        'Request accepted successfully',
                        'Error occurred while accepting request',
                      )
                    }
                  >
                    {order?.status === SPA_STATUS_NEW_REQUEST ? 'Accept Request' : 'Accepted'}
                  </Button>
                )}
                {(order?.status === SPA_STATUS_NEW_REQUEST ||
                  order?.status === SPA_STATUS_DECLINED) && (
                  <Button
                    variant='outlined'
                    type='button'
                    className='spa-reject-request-button mx-4'
                    style={{ color: '#E04667', borderColor: '#E04667' }}
                    onClick={() => onClickDeclineRequest()}
                  >
                    <span className='mx-2'>
                      {order?.status === SPA_STATUS_DECLINED
                        ? 'Request Declined'
                        : 'Decline Request'}
                    </span>
                    {order?.status !== SPA_STATUS_DECLINED && <CancelIcon />}
                  </Button>
                )}
              </div>
              <div className='col-md-5 justify-content-end'>
                {(order?.status === SPA_STATUS_ARRIVING_TODAY ||
                  order?.status === SPA_STATUS_SCHEDULED) && (
                  <Button
                    variant='outlined'
                    color='secondary'
                    type='button'
                    className='btn-delayed mx-4'
                    onClick={() => onClickGuestCancelled()}
                  >
                    Guest Cancelled
                  </Button>
                )}
                {(order?.status === SPA_STATUS_ARRIVING_TODAY ||
                  order?.status === SPA_STATUS_SCHEDULED) && (
                  <Button
                    variant='contained'
                    color='primary'
                    type='button'
                    onClick={() => onClickCompleteRequest()}
                  >
                    Complete Appointment
                  </Button>
                )}
              </div>
            </div>
          </div>
          {selectedValue.status && (
            <ActivationPopupModel
              activationPopUp={selectedValue}
              cancelButtonName='No'
              okButtonName='Yes'
              onOkClick={onOkClick}
              onActivationPopupActionCancel={handleClose}
            />
          )}
        </div>
      )}
    </>
  );
};

export default DashboardSpaView;
